import { useCreateVenue, VenueCategoryUnionType } from '@api';
import { useNotification, VenueFormValuesType } from '@common';
import { AxiosError } from 'axios';

const TRANS_KEY = 'NOTIFICATIONS.ADD_VENUE';

type UseSubmitNewVenueReturnType = {
  submitNewVenue: (data: VenueFormValuesType) => Promise<void>;
};

export const useSubmitNewVenue = (): UseSubmitNewVenueReturnType => {
  const { mutateAsync: createVenue } = useCreateVenue();

  const { showSuccess, showError } = useNotification();

  const onSuccess = () => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError) => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error,
    });
  };

  const submitNewVenue = async (data: VenueFormValuesType) => {
    await createVenue(
      { data: { ...data, category: data.category as VenueCategoryUnionType } },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { submitNewVenue };
};
